module.exports = "/packs/images/components/transient_navigation/childrens-swimming-lessons-nav-banner~8408119588a68dd819ee113860d67294.jpg";